export const namespacedPrefix = '[AUTH]';
